import React from 'react';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import WorkLink from './WorkLink';

export default class WorkTree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: []
        }

        this.load = this.load.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    handleChange(event, nodes) {
        this.setState({ expanded: nodes})
    };

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/GetWorkTree?workId=' + this.props.workId, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ work: result, expanded: [result.id] });
                }).catch((err) => console.log(err));
            }
        });
    }

    generateChildItems(work) {
        return (
            <TreeItem classes={{ group: "work-tree-group" }} nodeId={work.id} label={<div class={"work-tree-item " + (work.isMain ? "main" : "")}><div><WorkLink workId={work.id} number={work.number} /></div><div>{work.caption}</div><div>{work.status}</div><div>Факт: {work.factTotal}ч</div></div>}>
                {work.childs && work.childs.map(w => this.generateChildItems(w))}
            </TreeItem>
            );
    }

    render() {
        return (
            <div>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    expanded={this.state.expanded}
                    onNodeToggle={this.handleChange}>
                    {this.state.work && this.generateChildItems(this.state.work)}
                </TreeView>
            </div>
        );
    }
}
